export default "<p>{{ErrorMsg}}</p>\n"